<template>
  <v-col
    cols="12"
    :sm="device.isDesktop ? 6 : 12"
  >
    <v-row>
      <category-menu-select-date
        v-if="device.isDesktop"
        :selected-date="selectedDate"
        @subOneDay="$emit('change-day', -1)"
        :title="$t('pages.category_menu.sentence_1_0')"
        @addOneDay="$emit('change-day', 1)"
      ></category-menu-select-date>
      <v-col cols="12" v-if="selectedCategory && selectedShiftKey">
        <!-- Mobile / Tablet: all categories stacked, each item full width -->
        <v-row v-if="!device.isDesktop">
          <v-col
            cols="12"
            v-for="(foodCategory, i) in Object.keys(selectedMenu[selectedShiftKey])"
            :key="i"
            class="mb-4"
          >
            <h2 class="mb-4 title">{{ foodCategory }}</h2>

            <v-row>
              <v-col
                cols="12"
                v-for="(item, j) in selectedMenu[selectedShiftKey][foodCategory]"
                :key="j"
              >
                <category-menu-group-card
                  :item="item"
                  :is-selected="
                    selectedCategories.some((i) => i.foods.find((ii) => ii.id == item.id))
                  "
                  :disabled="checkDisabled"
                  @subFood="$emit('sub-food', item)"
                  @addFood="$emit('add-food', item)"
                />
                <v-divider
                  v-if="j < selectedMenu[selectedShiftKey][foodCategory].length - 1"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Desktop: selected category single column -->
        <template v-else>
          <v-col
            cols="12"
            v-for="(item, index) in selectedMenu[selectedShiftKey][selectedCategory]"
            :key="index"
            style="cursor: pointer"
            @click="!checkDisabled && !isCompanyRole && $emit('add-food', item)"
            class="pt-0"
          >
            <category-menu-group-card
              :item="item"
              :is-selected="
                selectedCategories.some((i) => i.foods.find((ii) => ii.id == item.id))
              "
              :disabled="checkDisabled"
              @subFood="$emit('sub-food', item)"
              @addFood="$emit('add-food', item)"
            />
            <v-divider class="mt-4" />
          </v-col>
        </template>
      </v-col>
      <v-col cols="12" v-else>
        <v-alert dense text type="warning" color="primary">
          {{ $t("pages.category_menu.sentence_2") }}
        </v-alert>
        <category-menu-select-date
          :selected-date="selectedDate"
          @subOneDay="$emit('change-day', -1)"
          :title="$t('pages.category_menu.sentence_1_0')"
          @addOneDay="$emit('change-day', 1)"
        />
      </v-col>
      <v-col cols="12" v-if="!device.isDesktop">
        <v-btn
          block
          color="primary"
          class="white--text"
          @click="!checkDisabled ? $emit('submit') : null"
          :disabled="hasExistingOrder && checkDisabled"
          style="position: sticky; text-transform: none"
          height="46"
        >
          <v-icon>mdi-cart-outline</v-icon>
          {{
            hasExistingOrder
              ? $t("pages.category_menu.sentence_8")
              : $t("pages.category_menu.sentence_7")
          }}
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import CategoryMenuSelectDate from "@/components/categoryMenu/CategoryMenuSelectDate.vue";
import CategoryMenuGroupCard from "@/components/categoryMenuGroup/CategoryMenuGroupCard.vue";

export default {
  name: "CategoryMenuGroupItemsList",
  components: {
    CategoryMenuSelectDate,
    CategoryMenuGroupCard,
  },
  props: {
    selectedMenu: {
      type: Object,
      default: null,
    },
    selectedDate: {
      type: String,
      required: true,
    },
    selectedCategory: {
      type: String,
      default: null,
    },
    selectedShiftKey: {
      type: String,
      default: null,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    checkDisabled: {
      type: Boolean,
      default: false,
    },
    hasExistingOrder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCompanyRole() {
      return this.$store.state.user.user?.type === "company";
    },
  },
};
</script>
